import { SelectMenuGrid } from './select-menu-grid.js';
import { SelectMenuGridSquare, SelectMenuGridColorCircle, SelectMenuGridWithLabel, SelectMenuGridOption } from './select-menu-grid-option.js';
var SelectMenu = {
  Option: SelectMenuGridOption,
  Grid: SelectMenuGrid
};
SelectMenu.Option.Square = SelectMenuGridSquare;
SelectMenu.Option.ColorCircle = SelectMenuGridColorCircle;
SelectMenu.Option.WithLabel = SelectMenuGridWithLabel;
export { SelectMenu };